
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    //@Serenity.Decorators.panel()
    export class ExpenseDialog extends _Ext.DialogBase<ExpenseRow, any> {
        protected getFormKey() { return ExpenseForm.formKey; }
        protected getIdProperty() { return ExpenseRow.idProperty; }
        protected getLocalTextPrefix() { return ExpenseRow.localTextPrefix; }
        protected getNameProperty() { return ExpenseRow.nameProperty; }
        protected getService() { return ExpenseService.baseUrl; }
        protected getDeletePermission() { return ExpenseRow.deletePermission; }
        protected getInsertPermission() { return ExpenseRow.insertPermission; }
        protected getUpdatePermission() { return ExpenseRow.updatePermission; }
        protected useViewMode() { return true; }
        public form = new ExpenseForm(this.idPrefix);
        public knockoffvalue;
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false; 
            return opt;
        }
        constructor() {
            super();

            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initDetailEditor(this, this.form.Details, Config);
            //q.setTextRightAlign(this.form.TdsTotal.element);
            q.hideEditorTab(this.form.Details);

            q.setTextRightAlign(this.form.TotalAmount);
            q.setTextRightAlign(this.form.TaxAmount);
            this.form.CurrencyId.changeSelect2(e => {
                //set Exchange Rate feild of Detail Grid Dialog
                var exchangerate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                this.form.Details.exchangerate = exchangerate[0].ExchRate;
                //new ExpenseDetaildialog().exchangerate = 1;
                Q.Authorization.userDefinition.exchangerate = exchangerate[0].ExchRate;
            });

            //set Total Amount on Payment Grid Change
            (this.form.Details.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals()
            });


            this.validateForm();
        }
        public CalculateTotals() {
            var amt = 0;
            var txamt = 0;
            for (var k of this.form.Details.getItems()) {
                amt += k.Amount;
                txamt += k.TaxAmount;
            }
            this.form.TotalAmount.value = amt;
            this.form.TaxAmount.value = txamt;
        }
        protected onDialogOpen() {
            super.onDialogOpen();

            //Allow BackDated Entry
            var isDateEditable = OMS.VoucherMasterRow.getLookup().itemById[this.entity.VoucherTypeId].AllowBackDatedEntry;
            if (isDateEditable) {
                this.form.TransDate.set_readOnly(false);
                var StartDate = OMS.FinancialYearRow.getLookup().itemById[Q.Authorization.userDefinition.FinancialYearId].FromDate;
                var EndDate = OMS.FinancialYearRow.getLookup().itemById[Q.Authorization.userDefinition.FinancialYearId].ToDate;
                var maxDate = new Date(EndDate);
                var minDate = new Date(StartDate);
                q.setMaxDate(this.form.TransDate, maxDate);
                q.setMinDate(this.form.TransDate, minDate);
            }
            if (this.form.LedgerId.value != "") {
                //set Party Balance Grid in Edit Mode
                let values;
                var exchangerate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                this.form.Details.exchangerate = exchangerate[0].ExchRate;
                this.form.ExchangeRate.value = exchangerate[0].ExchRate;
                //new ExpenseDetaildialog().exchangerate = 1;
                Q.Authorization.userDefinition.exchangerate = exchangerate[0].ExchRate;

            }
            else {
                //set Default Values based on Login
                this.form.EnteredBy.value = Q.Authorization.userDefinition.Username;
                Serenity.EditorUtils.setReadOnly(this.form.EnteredBy, true);
                this.form.UserId.value = Q.Authorization.userDefinition.UserId;
                this.form.CurrencyId.value = Q.Authorization.userDefinition.CurrencyId.toString();
                var exchangerate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                this.form.Details.exchangerate = exchangerate[0].ExchRate;
                this.form.ExchangeRate.value = exchangerate[0].ExchRate;
                //new ExpenseDetaildialog().exchangerate = 1;
                Q.Authorization.userDefinition.exchangerate = exchangerate[0].ExchRate;
            }
        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            var buttons = super.getToolbarButtons();

            var btnDelete = Q.first(buttons, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            //Report Generation Button
            buttons.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Finance.Payment',
                getParams: () => ({
                    PaymentID: this.get_entityId()
                })
            }));
            return buttons;
        }

        protected updateTitle() {

            //get Back Button on the Dialog
            this.dialogTitle = "Expense Voucher";
        }

        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            //if (this.canDelete) {
            ExpenseService.Delete(
                {

                    EntityId: this.entityId
                }, response => {
                    Serenity.SubDialogHelper.triggerDataChange(self);
                    self.dialogClose();
                    window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                });
            //} else {
            //    Q.alert("Further Payments for the Vouchers have been made, Cannot delete");
            //    return;
            //}

        }
    }




}
